<template>
  <div class="checkout-details col-md-12 col-xs-12 ls-display-flex flex-wrap ls-md-margin-top row-reverse ls-no-padding">
    <div class="col-md-4 col-xs-12 col-sm-6 ls-no-padding-left ls-no-padding-right mobile-margin-top ls-md-padding-top ls-md-margin-bottom">
      <invoice-details :invoice="invoice"></invoice-details>
    </div>
    <div class="col-md-8 col-sm-6 col-xs-12 ls-no-padding ls-sm-margin-bottom">
      <div class="ls-box full-height ls-no-padding margin-right">
        <h5 class="subtitle ls-sm-margin-top">{{ $t('payments.methods.select_method') }}:</h5>
        <hr class="margin-bottom">
        <div class="ls-display-flex justify-content-center flex-wrap">
          <div v-if="useBilletMethod" @click="loadBillet" class="col-md-3 col-sm col-xs-12" :class="boxPaymentSize + ' payment-method-box margin-bottom'">
            <div class="ls-txt-center">
              <h5 class="ls-display-block ls-xs-margin-bottom">{{ $t('payments.methods.billet') }}</h5>
              <i aria-hidden="true" class="fa fa-4x fa-barcode"></i><br>
            </div>
          </div>
          <div v-if="useCardMethod" @click="loadCard" class="col-md-3 col-xs-12" :class="boxPaymentSize + ' payment-method-box margin-bottom'">
            <div class="ls-txt-center">
              <h5 class="ls-display-block ls-xs-margin-bottom">{{ $t('payments.methods.card') }}</h5>
              <i aria-hidden="true" class="fa fa-4x fa-credit-card"></i><br>
            </div>
          </div>
          <div v-if="useTransferMethod" @click="loadTransfer" class="col-md-3 col-xs-12" :class="boxPaymentSize + ' payment-method-box margin-bottom'">
            <div class="ls-txt-center">
              <h5 class="ls-display-block ls-xs-margin-bottom">{{ $t('payments.methods.transfer') }}</h5>
              <i aria-hidden="true" class="fa fa-4x fa-exchange"></i><br>
            </div>
          </div>
          <div v-if="useBalanceMethod" @click="loadLoginYapay" class="col-md-3 col-xs-12" :class="boxPaymentSize + ' payment-method-box margin-bottom'">
            <div class="ls-txt-center">
              <h5 class="ls-display-block ls-xs-margin-bottom ls-no-padding">{{ $t('payments.methods.yapay_balance') }}</h5>
              <img class="ls-sm-margin-top icon small-icon" v-bind:src="require('../../../assets/img/logo-vindi-grey.png')">
            </div>
          </div>
          <div v-if="useNoPaymentSettings" class="ls-txt-center">
            <span>Não existe forma de pagamento disponível para essa fatura.</span><br>
            <span>Entre em contato com o vendedor.</span>
          </div>
        </div>
        <div v-if="customer" class='col-md-12 ls-sm-margin-bottom'>
          <hr>
          <h4>Informações do cliente:</h4><br>
          {{ customer.name }}<br>
          {{ customer.trade_name }}<br>
          {{ customer.email }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import * as location from 'src/utils/location'
  import Billet from './Billet.vue'
  import Card from './Card.vue'
  import InvoiceDetails from './components/InvoiceDetails.vue'

  export default {
    props: ['message'],
    components: { Billet, Card, InvoiceDetails },
    data () {
      return {
      }
    },
    methods: {
      ...mapActions(['loadSellerData', 'loadInvoiceById']),
      ...mapMutations(['clearFlash', 'addFlash']),
      getUsernameFromUrl: function () {
        return location.getUsername()
      },
      loadBillet () {
        this.$parent.loadBillet()
      },
      loadCard () {
        this.$parent.loadCard()
      },
      loadTransfer () {
        this.$parent.loadTransfer()
      },
      loadLoginYapay () {
        this.$parent.loadLoginYapay()
      }
    },
    created () {
    },
    computed: {
      ...mapGetters(['basicSeller', 'invoice']),
      invoice_id () {
        return this.$route.params.id
      },
      boxPaymentSize () {
        var paymentSettings = this.invoice.payment_settings
        var methodsCount = 0

        if (!paymentSettings) return

        for (var k in paymentSettings) {
          if (paymentSettings[k] === true) {
            methodsCount++
          }
        }
        if (methodsCount === 1) {
          return 'col-md-12'
        }
        if (methodsCount === 2) {
          return 'col-md-6'
        }
        return 'col-md-4'
      },
      customer () {
        return this.invoice.customer
      },
      useCardMethod () {
        if (this.invoice.payment_settings) {
          return this.invoice.payment_settings.card
        }
      },
      useTransferMethod () {
        if (this.invoice.payment_settings) {
          return this.invoice.payment_settings.transfer
        }
      },
      useBilletMethod () {
        if (this.invoice.payment_settings) {
          return this.invoice.payment_settings.billet
        }
      },
      useBalanceMethod () {
        if (this.invoice.payment_settings) {
          return this.invoice.payment_settings.balance
        }
      },
      useNoPaymentSettings () {
        return (!this.useCardMethod && !this.useTransferMethod && !this.useBilletMethod && !this.useBalanceMethod)
      }
    }
  }
</script>
<style>
  .d-flex {
    display: flex;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .justify-content-center {
    justify-content: center;
  }
  .icon {
    max-width: 40%;
    max-height: 40%;
  }
  @media (min-width: 767px)
  {
    .margin-right {
      margin-right: 10px;
    }
    .row-reverse {
      flex-direction: row-reverse;
    }
  }
  @media (max-width: 767px)
  {
    .mobile-margin-top {
      margin-top: 30px;
    }
    .small-icon {
      max-width: 30%;
      max-height: 30%;
    }
  }
</style>



// WEBPACK FOOTER //
// ChoosePayment.vue?2e972f56